import { EditorialErrorIdentifier } from '@/components/EditorialErrors/EditorialErrors';
import {
	AdditionalInformation,
	convertStrapiSingleMediaOrArrayToMediaArray,
} from '@/lib/apiTypes';

const identifyMediaWithWrongMimeType: EditorialErrorIdentifier = ({
	useSpecies,
}) => {
	const { species } = useSpecies;
	if (!species) return [];

	return species.data
		.map((singleSpecies) => {
			const media = [
				...convertStrapiSingleMediaOrArrayToMediaArray(
					singleSpecies.attributes.imageMain,
				),
				...Object.values(singleSpecies.attributes.speciesDescription)
					.filter(
						(speciesDescriptionItem) =>
							typeof speciesDescriptionItem !== 'number',
					)
					.map((description: AdditionalInformation) =>
						convertStrapiSingleMediaOrArrayToMediaArray(
							description.media,
						),
					),
			].flat();

			// Filter out images that are correct (jpg or webp) and audio that is correct (mp3)
			const wrongMedia = media.filter(
				(mediaItem) =>
					!['image/jpeg', 'image/webp', 'audio/mpeg'].includes(
						mediaItem.mime,
					),
			);

			return {
				species: singleSpecies,
				wrongMedia: wrongMedia,
			};
		})
		.filter(({ wrongMedia }) => wrongMedia.length > 0)
		.map(({ wrongMedia, species }) => ({
			title: 'Media met verkeerde type',
			description: (
				<>
					{species.attributes.titleShort} heeft media die niet van het
					type jpg, webp of mp3 is. Hierdoor kan het mogelijk niet op
					ieder apparaat worden gelezen of snel genoeg worden geladen.
					Het gaat om deze items:{' '}
					{wrongMedia.map((mediaItem, index, array) => (
						<>
							<a
								key={mediaItem.url}
								href={mediaItem.url}
								target="_blank"
								className="text-secondary underline">
								item {index} als {mediaItem.mime}
							</a>
							{index === array.length - 1 ? '' : ', '}
						</>
					))}
				</>
			),
			speciesId: species.id,
		}));
};

export default identifyMediaWithWrongMimeType;
